const BACKEND_URL =
  process.env.NODE_ENV === "production"
    ? ""
    : process.env.REACT_APP_BACKEND_URL || "http://localhost:5050";

const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000";

export { BACKEND_URL, FRONTEND_URL };
